/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React from "react";
import { Nav, Tab } from "react-bootstrap";
import SideBarNavigationTabAIChatBot from './SideBarNavigationTabAIChatBot';
import NewAIChatBot from './NewAIChatBot';
import ResumeAIChatBot from './ResumeAIChatBot';
import { RiChatAiLine } from "react-icons/ri";
import AIChatBotIcon from "../../../../_metronic/layout/assets/aichatbotbeta.png";
import { RiArrowUpCircleFill } from 'react-icons/ri';
import { injectIntl } from "react-intl";
import { connect } from "react-redux";

class SidePanelAIChatBot extends React.Component {
    state = {
        selectedTab: "1",
        resumedSession: null
    };

    setTab = _tabName => {
        this.setState({ selectedTab: _tabName });
    };

    resumeAndSwitch = (sessionId, userQuestion, assistantResponse) => {
        this.setState({
            selectedTab: "1",
            resumedSession: { sessionId, userQuestion, assistantResponse }
        });
    };

    startNewChat = () => {
    if (this.newChatRef?.current?.startNewChat) {
        this.newChatRef.current.startNewChat();
    }
};

    render() {
        const { selectedTab, resumedSession } = this.state;

        return (
            <div style={{ marginTop: "2rem" }} className="kt-quick-panel__nav">
                <NewAIChatBot
                    newChatRequestId={this.props.newChatRequestId}
                    panelCloseBtnRef={this.props.panelCloseBtnRef}
                    isOpen={this.props.isOpen}
                    resumedSession={resumedSession}
                    authToken={this.props.authToken}
                    isNewChatTabActive={selectedTab === "1"}
                />
            </div>
            // <Tab.Container activeKey={selectedTab} onSelect={this.setTab}>
            //     <div style={{ marginTop: "2rem" }} className="kt-quick-panel__nav">
            //         <Nav
            //             activeKey={selectedTab}
            //             onSelect={this.setTab}
            //             className="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand kt-notification-item-padding-x"
            //         >
            //             <SideBarNavigationTabAIChatBot
            //                 title={this.props.intl.formatMessage({ id: 'OPTIONS.CHATBOT.NEWCHAT' })}
            //                 eventKey="1"
            //             />
            //             <SideBarNavigationTabAIChatBot
            //                 title={this.props.intl.formatMessage({ id: 'OPTIONS.CHATBOT.RESUMECHAT' })}
            //                 eventKey="2"
            //             />
            //         </Nav>
            //     </div>
            //     <div className="kt-quick-panel__content">
            //         <Tab.Content>
            //             <Tab.Pane eventKey="1">
            //                 <NewAIChatBot
            //                     panelCloseBtnRef={this.props.panelCloseBtnRef}
            //                     isOpen={this.props.isOpen}
            //                     resumedSession={resumedSession}
            //                     authToken={this.props.authToken}
            //                     isNewChatTabActive={selectedTab === "1"}
            //                 />
            //             </Tab.Pane>
            //             <Tab.Pane eventKey="2">
            //                 <ResumeAIChatBot
            //                     panelCloseBtnRef={this.props.panelCloseBtnRef}
            //                     isOpen={this.props.isOpen}
            //                     onSessionResume={this.resumeAndSwitch}
            //                     authToken={this.props.authToken}
            //                 />
            //             </Tab.Pane>
            //         </Tab.Content>
            //     </div>
            // </Tab.Container>
        );
    }
}

const mapStateToProps = store => ({
    authToken: store.auth.authToken
});

export default injectIntl(connect(mapStateToProps)(SidePanelAIChatBot));